(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-list"] && !Shopify.designMode) return;
  try {
     var swiper = new Swiper(".shop-player-swiper", { slidesPerView: 4, spaceBetween: 20, navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev", }, breakpoints: { 320: { slidesPerView: 1.2, spaceBetween: 10 }, 640: { slidesPerView: 2, spaceBetween: 15 }, 1024: { slidesPerView: 3.3, spaceBetween: 20 }, 1600: { slidesPerView: 4.3, spaceBetween: 20 } } }); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-slider"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.hero-swiper .swiper', {
    loop: true,
    speed: 700,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // ✅ helps avoid accidental clicks while swiping
    preventClicks: true,
    preventClicksPropagation: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.history-video');
    if (!section) return;

    const playBtn = section.querySelector('.play-btn');
    const videoFrame = section.querySelector('.video-frame');
    const iframe = videoFrame.querySelector('iframe');
    const placeholder = section.querySelector('.video-placeholder');

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        placeholder.style.display = 'none';
        videoFrame.style.display = 'block';
        iframe.src = '{{ section.settings.video_url }}?autoplay=1';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
